import {Component} from '@angular/core';
import {FormBuilder, Validators, FormsModule, FormGroup} from '@angular/forms';
import {MatInputModule} from '@angular/material/input';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatStepperModule} from '@angular/material/stepper';
import {MatCardModule} from '@angular/material/card';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatListModule} from '@angular/material/list';
import {CommonModule, NgFor} from '@angular/common';
import {BrowserModule} from '@angular/platform-browser';
import {ReactiveFormsModule} from '@angular/forms';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatNativeDateModule} from '@angular/material/core';
import {MatButtonModule} from '@angular/material/button';
import {MatIconModule} from '@angular/material/icon';
import {InfringementDTO} from '../../intefaces/infringementDTO.interface';
import {FormControl} from '@angular/forms';
import {Company} from '../../intefaces/company.interface';
import {CompanyService} from '../../services/company.service';
import {StatusMessageService} from '../../services/status-message.service';
import {InfringementService} from '../../services/infringement.service';
import {firstValueFrom} from 'rxjs';
import {Router} from '@angular/router';

@Component({
  selector: 'app-add-infringement',
  standalone: false,

  templateUrl: './add-infringement.component.html',
  styleUrl: './add-infringement.component.scss'
})

export class AddInfringementComponent {
  infringementDetails!: FormGroup;
  infringementDTO!: InfringementDTO;
  companies!: Company[];
  filteredCompanies: Company[] = [];
  isSaving: boolean = false;
  previewedIdentifier: string | null = null;
  isLoadingIdentifier: boolean = false;
  countries: { [key: string]: string } = {
    "AF": "Afghanistan",
    "AL": "Albania",
    "DZ": "Algeria",
    "AS": "American Samoa",
    "AD": "Andorra",
    "AO": "Angola",
    "AI": "Anguilla",
    "AQ": "Antarctica",
    "AG": "Antigua and Barbuda",
    "AR": "Argentina",
    "AM": "Armenia",
    "AW": "Aruba",
    "AU": "Australia",
    "AT": "Austria",
    "AZ": "Azerbaijan",
    "BS": "Bahamas",
    "BH": "Bahrain",
    "BD": "Bangladesh",
    "BB": "Barbados",
    "BY": "Belarus",
    "BE": "Belgium",
    "BZ": "Belize",
    "BJ": "Benin",
    "BM": "Bermuda",
    "BT": "Bhutan",
    "BO": "Bolivia",
    "BA": "Bosnia and Herzegovina",
    "BW": "Botswana",
    "BR": "Brazil",
    "BN": "Brunei",
    "BG": "Bulgaria",
    "BF": "Burkina Faso",
    "BI": "Burundi",
    "CV": "Cabo Verde",
    "KH": "Cambodia",
    "CM": "Cameroon",
    "CA": "Canada",
    "KY": "Cayman Islands",
    "CF": "Central African Republic",
    "TD": "Chad",
    "CL": "Chile",
    "CN": "China",
    "CO": "Colombia",
    "KM": "Comoros",
    "CG": "Congo (Congo-Brazzaville)",
    "CD": "Congo (Democratic Republic)",
    "CR": "Costa Rica",
    "CI": "Côte d’Ivoire",
    "HR": "Croatia",
    "CU": "Cuba",
    "CY": "Cyprus",
    "CZ": "Czechia",
    "DK": "Denmark",
    "DJ": "Djibouti",
    "DM": "Dominica",
    "DO": "Dominican Republic",
    "EC": "Ecuador",
    "EG": "Egypt",
    "SV": "El Salvador",
    "GQ": "Equatorial Guinea",
    "ER": "Eritrea",
    "EE": "Estonia",
    "SZ": "Eswatini",
    "ET": "Ethiopia",
    "FJ": "Fiji",
    "FI": "Finland",
    "FR": "France",
    "GA": "Gabon",
    "GM": "Gambia",
    "GE": "Georgia",
    "DE": "Germany",
    "GH": "Ghana",
    "GR": "Greece",
    "GD": "Grenada",
    "GU": "Guam",
    "GT": "Guatemala",
    "GN": "Guinea",
    "GW": "Guinea-Bissau",
    "GY": "Guyana",
    "HT": "Haiti",
    "HN": "Honduras",
    "HU": "Hungary",
    "IS": "Iceland",
    "IN": "India",
    "ID": "Indonesia",
    "IR": "Iran",
    "IQ": "Iraq",
    "IE": "Ireland",
    "IL": "Israel",
    "IT": "Italy",
    "JM": "Jamaica",
    "JP": "Japan",
    "JO": "Jordan",
    "KZ": "Kazakhstan",
    "KE": "Kenya",
    "KI": "Kiribati",
    "KR": "Korea (South)",
    "KP": "Korea (North)",
    "KW": "Kuwait",
    "KG": "Kyrgyzstan",
    "LA": "Laos",
    "LV": "Latvia",
    "LB": "Lebanon",
    "LS": "Lesotho",
    "LR": "Liberia",
    "LY": "Libya",
    "LI": "Liechtenstein",
    "LT": "Lithuania",
    "LU": "Luxembourg",
    "MG": "Madagascar",
    "MW": "Malawi",
    "MY": "Malaysia",
    "MV": "Maldives",
    "ML": "Mali",
    "MT": "Malta",
    "MH": "Marshall Islands",
    "MR": "Mauritania",
    "MU": "Mauritius",
    "MX": "Mexico",
    "FM": "Micronesia",
    "MD": "Moldova",
    "MC": "Monaco",
    "MN": "Mongolia",
    "ME": "Montenegro",
    "MA": "Morocco",
    "MZ": "Mozambique",
    "MM": "Myanmar",
    "NA": "Namibia",
    "NR": "Nauru",
    "NP": "Nepal",
    "NL": "Netherlands",
    "NZ": "New Zealand",
    "NI": "Nicaragua",
    "NE": "Niger",
    "NG": "Nigeria",
    "NO": "Norway",
    "OM": "Oman",
    "PK": "Pakistan",
    "PW": "Palau",
    "PA": "Panama",
    "PG": "Papua New Guinea",
    "PY": "Paraguay",
    "PE": "Peru",
    "PH": "Philippines",
    "PL": "Poland",
    "PT": "Portugal",
    "QA": "Qatar",
    "RO": "Romania",
    "RU": "Russia",
    "RW": "Rwanda",
    "KN": "Saint Kitts and Nevis",
    "LC": "Saint Lucia",
    "VC": "Saint Vincent and the Grenadines",
    "WS": "Samoa",
    "SM": "San Marino",
    "ST": "São Tomé and Príncipe",
    "SA": "Saudi Arabia",
    "SN": "Senegal",
    "RS": "Serbia",
    "SC": "Seychelles",
    "SL": "Sierra Leone",
    "SG": "Singapore",
    "SK": "Slovakia",
    "SI": "Slovenia",
    "SB": "Solomon Islands",
    "SO": "Somalia",
    "ZA": "South Africa",
    "SS": "South Sudan",
    "ES": "Spain",
    "LK": "Sri Lanka",
    "SD": "Sudan",
    "SR": "Suriname",
    "SE": "Sweden",
    "CH": "Switzerland",
    "SY": "Syria",
    "TJ": "Tajikistan",
    "TZ": "Tanzania",
    "TH": "Thailand",
    "TL": "Timor-Leste",
    "TG": "Togo",
    "TO": "Tonga",
    "TT": "Trinidad and Tobago",
    "TN": "Tunisia",
    "TR": "Turkey",
    "TM": "Turkmenistan",
    "TV": "Tuvalu",
    "UG": "Uganda",
    "UA": "Ukraine",
    "AE": "United Arab Emirates",
    "GB": "United Kingdom",
    "US": "United States",
    "UY": "Uruguay",
    "UZ": "Uzbekistan",
    "VU": "Vanuatu",
    "VA": "Vatican City",
    "VE": "Venezuela",
    "VN": "Vietnam",
    "YE": "Yemen",
    "ZM": "Zambia",
    "ZW": "Zimbabwe"
  };

  constructor(private fb: FormBuilder, private companyService: CompanyService, private statusMessage: StatusMessageService, private infringementService: InfringementService, private router: Router) {
  }

  ngOnInit(): void {
    this.infringementDetails = this.fb.group({
      infringementType: ['0'],
      accusedName: new FormControl(''),
      accusedURL: new FormControl(''),
      accusedCompany: ['', Validators.required],
      accusedCountry: new FormControl(''),
      externalLawyer: new FormControl(''),
      accusedEmail: new FormControl(''),
      responsibleEmployee: new FormControl(''),
      infringementDetails: new FormControl(''),
    });

    this.companyService.getCompanyList().subscribe({
      next: (data: any) => {
        this.companies = data;
        this.filteredCompanies = [...this.companies];
      },
      error: (error: any) => {
        this.statusMessage.showStatusMessage("Countries could not be loaded", "error");
      }
    })

    this.disableAccusedFields();
    this.loadNextIdentifier();

    // Re-fetch preview when infringementType changes
    this.infringementDetails.get('infringementType')?.valueChanges.subscribe(() => {
      this.loadNextIdentifier();
    });
  }

  private async loadNextIdentifier(): Promise<void> {
    const infringementType = Number(this.infringementDetails.get('infringementType')?.value ?? 0);
    this.isLoadingIdentifier = true;
    try {
      const response = await firstValueFrom(this.infringementService.getNextIdentifier(infringementType));
      this.previewedIdentifier = response.identifier;
    } catch (error) {
      this.previewedIdentifier = null;
      this.statusMessage.showStatusMessage("Could not load next identifier preview.", "error");
    } finally {
      this.isLoadingIdentifier = false;
    }
  }

  onCompanySelected(selected: any): void {
    if (selected === 'new') {
      // Option for "New Company": Clear or allow manual input.
      this.infringementDetails.patchValue({
        accusedName: '',
        accusedURL: '',
        accusedCountry: '',
        accusedAddress: '',
        accusedEmail: ''
      });
      this.enableAccusedFields();
      this.updateCompanySuggestions('');
    } else {
      // Prefill with selected company data.
      this.infringementDetails.patchValue({
        accusedName: selected.name,
        accusedURL: selected.url,
        accusedCountry: selected.countryCode,
        accusedAddress: selected.address,
        accusedEmail: selected.email
      });

      this.disableAccusedFields();
      this.filteredCompanies = [];
    }
  }

  async onSubmit() {
    if (this.isSaving) {
      return;
    }

    if (this.infringementDetails.invalid) {
      console.log("Form is invalid, please check the errors.");
      return;
    }


    this.infringementDTO = {
      "attachments": null,
      "contractValue": null,

      "accused": {
        "name": this.infringementDetails.controls['accusedName'].value,
        "url": this.infringementDetails.controls['accusedURL'].value,
        "email": this.infringementDetails.controls['accusedEmail'].value,
        "country": this.countries[this.infringementDetails.controls['accusedName'].value],
        "countryCode": this.infringementDetails.controls['accusedCountry'].value,
        "address": null
      },

      "debitor": null,


      "infringementType": this.infringementDetails.controls['infringementType'].value,
      "infringementStatus": 0,

      "infringementDetails": this.infringementDetails.controls['infringementDetails'].value,
      "genericComments": null,
      "responsibleEmployee": null,
      "lastUpdatedBy": null,
      "externalLawyer": null,
      "itSecurityCheck": {
        "checked": false,
        "itSecurityComments": null,
        "orderID": null,
      },

      "dateCreated": new Date().toISOString().split('T')[0],
      "dateClosed": null,
      "warningSent": null,
      "reminderDate": null,
      "secondReminderDate": null,
    }

    this.isSaving = true;

    try {
      const response = await firstValueFrom(this.infringementService.add(this.infringementDTO));
      const actualIdentifier = response?.identifier;

      if (this.previewedIdentifier && actualIdentifier && actualIdentifier !== this.previewedIdentifier) {
        this.statusMessage.showStatusMessage(
          `The assigned identifier is ${actualIdentifier} — it differs from the previewed ${this.previewedIdentifier} because another infringement was created in the meantime.`,
          'info'
        );
      } else {
        this.statusMessage.showStatusMessage("Infringement successfully added.", "affirmative");
      }

      await this.router.navigate(['/infringement-details', actualIdentifier]);
    } catch (error) {
      console.error("Error adding infringement", error);
      this.statusMessage.showStatusMessage("Infringement could not be added.", "error");
    } finally {
      this.isSaving = false;
    }

  }

  onAccusedNameBlur(): void {
    this.selectDetectedCompanyForNewAccused(true);
  }

  onAccusedNameInput(): void {
    const accusedName = (this.infringementDetails.get('accusedName')?.value ?? '').toString();
    this.updateCompanySuggestions(accusedName);
  }

  private selectDetectedCompanyForNewAccused(showNotification: boolean = false): boolean {
    const accusedCompany = this.infringementDetails.get('accusedCompany')?.value;

    if (accusedCompany !== 'new') {
      return false;
    }

    const accusedNameControl = this.infringementDetails.get('accusedName');
    if (!accusedNameControl) {
      return false;
    }

    const accusedName = (accusedNameControl.value ?? '').toString().trim();
    if (!accusedName) {
      return false;
    }

    const detectedCompany = (this.companies ?? []).find(company =>
      company.name?.trim().toLowerCase() === accusedName.toLowerCase()
    );

    if (!detectedCompany) {
      return false;
    }

    this.infringementDetails.patchValue({
      accusedCompany: detectedCompany
    });
    this.onCompanySelected(detectedCompany);

    if (showNotification) {
      this.statusMessage.showStatusMessage('Existing company detected. Company was selected automatically.', 'info');
    }

    return true;
  }

  private updateCompanySuggestions(searchValue: string): void {
    if (this.infringementDetails.get('accusedCompany')?.value !== 'new') {
      this.filteredCompanies = [];
      return;
    }

    const searchTerm = (searchValue ?? '').trim().toLowerCase();
    const companies = this.companies ?? [];

    if (!searchTerm) {
      this.filteredCompanies = [...companies];
      return;
    }

    this.filteredCompanies = companies.filter(company =>
      company.name?.toLowerCase().includes(searchTerm)
    );
  }

  disableAccusedFields() {
    this.infringementDetails.get('accusedName')?.disable();
    this.infringementDetails.get('accusedURL')?.disable();
    this.infringementDetails.get('accusedEmail')?.disable();
    this.infringementDetails.get('accusedCountry')?.disable();
  }

  enableAccusedFields() {
    this.infringementDetails.get('accusedName')?.enable();
    this.infringementDetails.get('accusedURL')?.enable();
    this.infringementDetails.get('accusedEmail')?.enable();
    this.infringementDetails.get('accusedCountry')?.enable();
  }
}
